import { X } from 'lucide-react'

import { m } from '@/lib/paraglide/messages'

export interface ListFilterChip {
    key: string
    label: string
    onRemove: () => void
}

/** Chip bộ lọc đang bật, gỡ được từng cái (R12). */
export function ListFilterChips({ chips }: { chips: ListFilterChip[] }) {
    if (chips.length === 0) return null
    return (
        <div data-testid="list-filter-chips" className="flex flex-wrap gap-2">
            {chips.map((chip) => (
                <span
                    key={chip.key}
                    className="bg-muted inline-flex items-center gap-1 rounded-full py-1 pr-1 pl-3 text-xs"
                >
                    {chip.label}
                    <button
                        type="button"
                        aria-label={m.common_filter_remove_chip({
                            label: chip.label,
                        })}
                        onClick={chip.onRemove}
                        className="hover:bg-background focus-visible:outline-ring rounded-full p-1 focus-visible:outline-2"
                    >
                        <X className="size-3" />
                    </button>
                </span>
            ))}
        </div>
    )
}
